<template>
  <span class="yb-upload-container">
    <el-button class="upload-file-button" :type="btnType" @click="upload">{{
      text
    }}</el-button>
    <input
      v-show="false"
      ref="filElem"
      type="file"
      class="upload-file"
      :accept="acceptUrl"
      @change="changeInputFileHandle"
    />
  </span>
</template>

<script>
  import { getExtName } from '@/utils/index';
  import newCosMixins from '@/mixins/newCos';
  export default {
    mixins: [newCosMixins],
    props: {
      maxFileCount: {
        type: Number,
        default: 0
      },
      currentFileCount: {
        type: Number,
        default: 0
      },
      text: {
        type: String,
        default: '选择文件'
      },
      btnType: {
        type: String,
        default: 'primary'
      },
      accept: {
        type: Array,
        default: () => []
      },
      maxSize: {
        type: Number,
        default: 5
      },
      businessName: {
        type: String,
        default: '',
        required: true
      }
    },
    data() {
      return {
        name: '',
        percentage: 0,
        acceptUrl: '',
        isLoading: false
      };
    },
    watch: {
      accept: {
        handler() {
          this.acceptUrl = this.accept.join(',');
        },
        immediate: true
      }
    },
    methods: {
      upload() {
        if (this.maxFileCount && this.currentFileCount >= this.maxFileCount) {
          this.$message.error(`最多上传${this.maxFileCount}个文件`);
          return;
        }
        if (this.isLoading) {
          this.$message.error('当前已有同类型文件正在上传中，请稍后再试');
          return;
        }
        this.$refs.filElem.value = null;
        this.$refs.filElem.dispatchEvent(new MouseEvent('click'));
      },
      handleFileUrl(data, file) {
        this.$emit('endUpload');
        this.$emit('uploadSuccess', {
          name: file.name,
          url: data.Location
        });
      },
      async changeInputFileHandle() {
        const inputFile = this.$refs.filElem.files[0];
        const { size, name } = inputFile;
        const extName = getExtName(name);
        if (this.accept.indexOf(`.${extName}`) === -1) {
          this.$message.error(`上传文件只能是${this.accept.join('、')}格式`);
          return;
        }

        if (encodeURIComponent(name).length > 1000) {
          this.$message.error(`上传的文件名过长，请修改后再试`);
          return;
        }

        if (size / 1024 / 1024 > this.maxSize) {
          this.$message.error(`上传的大小不能超过 ${this.maxSize}MB!`);
          return;
        }

        this.$emit('startUpload');
        this.submitCos(inputFile, this.businessName);
      }
    }
  };
</script>
<style lang="scss" scoped></style>
